var map = {
  "./AI_16.svg": "70280",
  "./AI_24.svg": "99878",
  "./accounting_ledger_16.svg": "57213",
  "./accounting_ledger_24.svg": "38248",
  "./accounting_report_16.svg": "69903",
  "./accounting_report_24.svg": "50665",
  "./action_log_16.svg": "39105",
  "./action_log_24.svg": "89855",
  "./activity_report_16.svg": "89918",
  "./activity_report_24.svg": "61068",
  "./add_16.svg": "96764",
  "./add_24.svg": "74447",
  "./add_customer_16.svg": "40200",
  "./add_customer_24.svg": "94357",
  "./add_photo_16.svg": "27626",
  "./add_photo_24.svg": "89218",
  "./alert_circle_16.svg": "84872",
  "./alert_circle_24.svg": "16585",
  "./analytics_16.svg": "4012",
  "./analytics_24.svg": "10009",
  "./archive_16.svg": "67813",
  "./archive_24.svg": "71378",
  "./arrivals_16.svg": "35368",
  "./arrivals_24.svg": "39196",
  "./arrow_counter_clockwise_1_16.svg": "1415",
  "./arrow_counter_clockwise_1_24.svg": "81291",
  "./arrow_counter_clockwise_2_16.svg": "33032",
  "./arrow_counter_clockwise_2_24.svg": "36660",
  "./arrow_counter_clockwise_3_16.svg": "46977",
  "./arrow_counter_clockwise_3_24.svg": "92879",
  "./arrow_counter_clockwise_4_16.svg": "62392",
  "./arrow_counter_clockwise_4_24.svg": "73442",
  "./arrow_counter_clockwise_5_16.svg": "2654",
  "./arrow_counter_clockwise_5_24.svg": "45013",
  "./arrow_counter_clockwise_6_16.svg": "24028",
  "./arrow_counter_clockwise_6_24.svg": "10725",
  "./arrow_counter_clockwise_7_16.svg": "56155",
  "./arrow_counter_clockwise_7_24.svg": "90643",
  "./arrow_counter_clockwise_8_16.svg": "7969",
  "./arrow_counter_clockwise_8_24.svg": "71014",
  "./arrow_counter_clockwise_9_16.svg": "48655",
  "./arrow_counter_clockwise_9_24.svg": "46737",
  "./arrow_counter_clockwise_9_plus_16.svg": "4431",
  "./arrow_counter_clockwise_9_plus_24.svg": "26267",
  "./arrow_down_16.svg": "32832",
  "./arrow_down_24.svg": "27135",
  "./arrow_joined_16.svg": "45495",
  "./arrow_joined_24.svg": "19273",
  "./arrow_left_16.svg": "75667",
  "./arrow_left_24.svg": "45863",
  "./arrow_right_16.svg": "9271",
  "./arrow_right_24.svg": "87639",
  "./arrow_up_16.svg": "79740",
  "./arrow_up_24.svg": "63674",
  "./assign_16.svg": "62295",
  "./assign_24.svg": "34778",
  "./at_mention_16.svg": "41595",
  "./at_mention_24.svg": "66406",
  "./availability_16.svg": "78295",
  "./availability_24.svg": "83216",
  "./available_dates_16.svg": "45352",
  "./available_dates_24.svg": "8533",
  "./baby_cot_16.svg": "33609",
  "./baby_cot_24.svg": "44989",
  "./backward_16.svg": "15003",
  "./backward_24.svg": "3867",
  "./backward_more_16.svg": "1176",
  "./backward_more_24.svg": "54929",
  "./bathroom_16.svg": "18804",
  "./bathroom_24.svg": "19823",
  "./bike_16.svg": "81539",
  "./bike_24.svg": "87453",
  "./bills_invoices_16.svg": "98859",
  "./bills_invoices_24.svg": "51998",
  "./birthday_16.svg": "31900",
  "./birthday_24.svg": "53581",
  "./blacklist_16.svg": "35364",
  "./blacklist_24.svg": "10710",
  "./bold_16.svg": "32282",
  "./bold_24.svg": "41739",
  "./breadcrumb_16.svg": "8486",
  "./breadcrumb_24.svg": "68789",
  "./briefcase_16.svg": "80423",
  "./briefcase_24.svg": "37147",
  "./broom_16.svg": "52971",
  "./broom_24.svg": "55474",
  "./building_plus_16.svg": "82226",
  "./building_plus_24.svg": "39147",
  "./bulb_stars_16.svg": "18350",
  "./bulb_stars_24.svg": "54715",
  "./bulk_edit_16.svg": "25612",
  "./bulk_edit_24.svg": "63177",
  "./bus_16.svg": "90460",
  "./bus_24.svg": "66723",
  "./calendar_16.svg": "84174",
  "./calendar_24.svg": "22181",
  "./calendar_day_16.svg": "37010",
  "./calendar_day_24.svg": "53533",
  "./calendar_month_16.svg": "57900",
  "./calendar_month_24.svg": "81442",
  "./calendar_stars_16.svg": "91116",
  "./calendar_stars_24.svg": "74818",
  "./calendar_week_16.svg": "28379",
  "./calendar_week_24.svg": "41228",
  "./call_16.svg": "36441",
  "./call_24.svg": "40041",
  "./camera_16.svg": "22576",
  "./camera_24.svg": "95141",
  "./camping_pitch_16.svg": "77088",
  "./camping_pitch_24.svg": "85742",
  "./cancel_square_16.svg": "45881",
  "./cancel_square_24.svg": "93872",
  "./caravan_16.svg": "39732",
  "./caravan_24.svg": "53220",
  "./card_check_16.svg": "9376",
  "./card_check_24.svg": "35835",
  "./card_keys_16.svg": "87589",
  "./card_keys_24.svg": "62079",
  "./card_nfc_16.svg": "9298",
  "./card_nfc_24.svg": "32672",
  "./caret_filled_down_16.svg": "25805",
  "./caret_filled_down_24.svg": "32484",
  "./caret_filled_up_16.svg": "20069",
  "./caret_filled_up_24.svg": "77155",
  "./cash_payment_16.svg": "53696",
  "./cash_payment_24.svg": "59659",
  "./cashier_16.svg": "85917",
  "./cashier_24.svg": "82592",
  "./cashlist_16.svg": "12555",
  "./cashlist_24.svg": "86957",
  "./channel_manager_16.svg": "74880",
  "./channel_manager_24.svg": "27578",
  "./charge_16.svg": "14802",
  "./charge_24.svg": "97992",
  "./chargeable_16.svg": "40166",
  "./chargeable_24.svg": "89970",
  "./chargeback_16.svg": "28444",
  "./chargeback_24.svg": "43559",
  "./checkbox_empty_16.svg": "6423",
  "./checkbox_empty_24.svg": "92584",
  "./checkbox_minus_16.svg": "64453",
  "./checkbox_plus_16.svg": "25081",
  "./checkbox_tick_16.svg": "8175",
  "./checkbox_tick_24.svg": "31044",
  "./checked_in_16.svg": "45265",
  "./checked_in_24.svg": "54669",
  "./checked_out_16.svg": "5336",
  "./checked_out_24.svg": "36539",
  "./checkin_16.svg": "1847",
  "./checkin_24.svg": "96232",
  "./checkout_16.svg": "17842",
  "./checkout_24.svg": "10303",
  "./chevron_down_16.svg": "47671",
  "./chevron_down_24.svg": "25344",
  "./chevron_left_16.svg": "53933",
  "./chevron_left_24.svg": "91503",
  "./chevron_right_16.svg": "46040",
  "./chevron_right_24.svg": "75909",
  "./chevron_up_16.svg": "53968",
  "./chevron_up_24.svg": "54708",
  "./child_head_16.svg": "52406",
  "./child_head_24.svg": "16874",
  "./city_16.svg": "87744",
  "./city_24.svg": "48807",
  "./clear_selection_16.svg": "70494",
  "./clear_selection_24.svg": "50538",
  "./collapse_16.svg": "9597",
  "./collapse_24.svg": "17133",
  "./collapse_all_16.svg": "67471",
  "./collapse_all_24.svg": "14034",
  "./companies_16.svg": "45667",
  "./companies_24.svg": "54152",
  "./complaint_16.svg": "35447",
  "./complaint_24.svg": "95851",
  "./configuration_16.svg": "10035",
  "./configuration_24.svg": "52683",
  "./connect_16.svg": "44531",
  "./connect_24.svg": "15614",
  "./copy_16.svg": "45993",
  "./copy_24.svg": "9255",
  "./countries_16.svg": "790",
  "./countries_24.svg": "56148",
  "./covid_protection_16.svg": "19735",
  "./covid_protection_24.svg": "90669",
  "./credit_card_file_16.svg": "58024",
  "./credit_card_file_24.svg": "51082",
  "./credit_card_report_16.svg": "2298",
  "./credit_card_report_24.svg": "73031",
  "./crib_16.svg": "36091",
  "./crib_24.svg": "90584",
  "./cross_close_16.svg": "78036",
  "./cross_close_24.svg": "16498",
  "./cultures_16.svg": "52090",
  "./cultures_24.svg": "63516",
  "./currency_switch_16.svg": "78261",
  "./currency_switch_24.svg": "5174",
  "./custom_link_16.svg": "6240",
  "./custom_link_24.svg": "66527",
  "./custom_link_item_16.svg": "90820",
  "./custom_link_item_24.svg": "91342",
  "./customer_profiles_16.svg": "35498",
  "./customer_profiles_24.svg": "83185",
  "./customer_success_16.svg": "95583",
  "./customer_success_24.svg": "61622",
  "./dashboard_16.svg": "53791",
  "./dashboard_24.svg": "15241",
  "./delete_16.svg": "2750",
  "./delete_24.svg": "75338",
  "./departures_16.svg": "89987",
  "./departures_24.svg": "47087",
  "./deployments_16.svg": "90879",
  "./deployments_24.svg": "95131",
  "./desk_16.svg": "79840",
  "./desk_24.svg": "54665",
  "./device_command_16.svg": "31208",
  "./device_command_24.svg": "79255",
  "./disability_16.svg": "30647",
  "./disability_24.svg": "15882",
  "./disable_16.svg": "63931",
  "./disable_24.svg": "46069",
  "./dollar_arrow_down_16.svg": "32278",
  "./dollar_arrow_down_24.svg": "57274",
  "./done_16.svg": "96022",
  "./done_24.svg": "66418",
  "./done_circle_16.svg": "55539",
  "./done_circle_24.svg": "86752",
  "./door_hanger_16.svg": "57528",
  "./door_hanger_24.svg": "5858",
  "./double_bed_16.svg": "52821",
  "./double_bed_24.svg": "50243",
  "./download_16.svg": "24310",
  "./download_24.svg": "60513",
  "./draggable_16.svg": "70399",
  "./draggable_24.svg": "86211",
  "./driving_licence_16.svg": "90209",
  "./driving_licence_24.svg": "3054",
  "./edit_16.svg": "72864",
  "./edit_24.svg": "69289",
  "./education_16.svg": "59278",
  "./education_24.svg": "52541",
  "./email_queue_16.svg": "67578",
  "./email_queue_24.svg": "3602",
  "./email_queues_16.svg": "154",
  "./email_queues_24.svg": "18036",
  "./employees_16.svg": "42280",
  "./employees_24.svg": "38242",
  "./enterprise_snapshot_16.svg": "67592",
  "./enterprise_snapshot_24.svg": "77353",
  "./error_circle_16.svg": "98480",
  "./error_circle_24.svg": "79761",
  "./execute_16.svg": "35794",
  "./execute_24.svg": "65133",
  "./execute_merchant_16.svg": "13440",
  "./execute_merchant_24.svg": "86111",
  "./expand_16.svg": "6230",
  "./expand_24.svg": "90108",
  "./expand_all_16.svg": "37075",
  "./expand_all_24.svg": "49887",
  "./experiences_16.svg": "31202",
  "./experiences_24.svg": "74593",
  "./export_schedule_16.svg": "83118",
  "./export_schedule_24.svg": "64674",
  "./exports_16.svg": "20892",
  "./exports_24.svg": "60471",
  "./external_link_16.svg": "68114",
  "./external_link_24.svg": "27160",
  "./external_payment_16.svg": "97415",
  "./external_payment_24.svg": "8417",
  "./extrabed_16.svg": "54904",
  "./extrabed_24.svg": "37577",
  "./face_happy_16.svg": "94711",
  "./face_happy_24.svg": "86121",
  "./face_id_16.svg": "59858",
  "./face_id_24.svg": "92491",
  "./face_sad_16.svg": "78254",
  "./face_sad_24.svg": "59063",
  "./facebook_16.svg": "47184",
  "./facebook_24.svg": "82255",
  "./fast_backward_simple_16.svg": "10318",
  "./fast_backward_simple_24.svg": "85965",
  "./fast_forward_simple_16.svg": "25709",
  "./fast_forward_simple_24.svg": "69317",
  "./features_16.svg": "129",
  "./features_24.svg": "47832",
  "./female_16.svg": "63867",
  "./female_24.svg": "59831",
  "./file_check_16.svg": "97291",
  "./file_check_24.svg": "63582",
  "./filter_16.svg": "17490",
  "./filter_24.svg": "15568",
  "./finance_16.svg": "23750",
  "./finance_24.svg": "94062",
  "./fiscal_report_16.svg": "50658",
  "./fiscal_report_24.svg": "56188",
  "./floppy_disc_16.svg": "72455",
  "./floppy_disc_24.svg": "7701",
  "./folder_closed_16.svg": "69901",
  "./folder_closed_24.svg": "35741",
  "./folder_opened_16.svg": "74143",
  "./folder_opened_24.svg": "38864",
  "./food_16.svg": "20653",
  "./food_24.svg": "23426",
  "./forum_outline_16.svg": "54606",
  "./forum_outline_24.svg": "96026",
  "./forward_16.svg": "81158",
  "./forward_24.svg": "13576",
  "./forward_more_16.svg": "70241",
  "./forward_more_24.svg": "25197",
  "./free_16.svg": "10409",
  "./free_24.svg": "86900",
  "./friend_family_16.svg": "71804",
  "./friend_family_24.svg": "27362",
  "./ftp_16.svg": "70275",
  "./ftp_24.svg": "69174",
  "./gateway_payments_16.svg": "84226",
  "./gateway_payments_24.svg": "72365",
  "./gift_16.svg": "11066",
  "./gift_24.svg": "10488",
  "./guest_in_house_16.svg": "37138",
  "./guest_in_house_24.svg": "98357",
  "./guides_16.svg": "78367",
  "./guides_24.svg": "75856",
  "./help_16.svg": "39450",
  "./help_24.svg": "36491",
  "./help_center_16.svg": "52630",
  "./help_center_24.svg": "75666",
  "./hide_16.svg": "87841",
  "./hide_24.svg": "24124",
  "./home_16.svg": "20454",
  "./home_24.svg": "83898",
  "./home_empty_16.svg": "26950",
  "./home_empty_24.svg": "45096",
  "./hourglass_16.svg": "12204",
  "./hourglass_24.svg": "82452",
  "./house_use_16.svg": "994",
  "./house_use_24.svg": "84317",
  "./id_card_16.svg": "7426",
  "./id_card_24.svg": "15023",
  "./import_16.svg": "44582",
  "./import_24.svg": "80749",
  "./import_customers_16.svg": "40006",
  "./import_customers_24.svg": "95553",
  "./important_16.svg": "97973",
  "./important_24.svg": "79767",
  "./imports_16.svg": "4761",
  "./imports_24.svg": "2408",
  "./improvement_16.svg": "15569",
  "./improvement_24.svg": "41624",
  "./info_16.svg": "34159",
  "./info_24.svg": "66035",
  "./installations_16.svg": "29899",
  "./installations_24.svg": "55",
  "./integration_partners_16.svg": "48171",
  "./integration_partners_24.svg": "35958",
  "./integrations_16.svg": "66684",
  "./integrations_24.svg": "37273",
  "./inventory_updates_16.svg": "38040",
  "./inventory_updates_24.svg": "90914",
  "./italic_16.svg": "79286",
  "./italic_24.svg": "27164",
  "./items_16.svg": "32454",
  "./items_24.svg": "34162",
  "./jobs_16.svg": "22788",
  "./jobs_24.svg": "70363",
  "./key_16.svg": "75793",
  "./key_24.svg": "42562",
  "./language_switch_16.svg": "38448",
  "./language_switch_24.svg": "33016",
  "./languages_16.svg": "99301",
  "./languages_24.svg": "59014",
  "./layout_grid_16.svg": "63052",
  "./layout_grid_24.svg": "33786",
  "./legal_environments_16.svg": "98712",
  "./legal_environments_24.svg": "96303",
  "./lightning_bolt_16.svg": "11382",
  "./lightning_bolt_24.svg": "54806",
  "./linkedin_16.svg": "79734",
  "./linkedin_24.svg": "93591",
  "./list_ordered_16.svg": "75496",
  "./list_ordered_24.svg": "73130",
  "./location_16.svg": "19445",
  "./location_24.svg": "48301",
  "./lock_16.svg": "79884",
  "./lock_24.svg": "8345",
  "./logout_16.svg": "87551",
  "./logout_24.svg": "91969",
  "./loyalty_16.svg": "60961",
  "./loyalty_24.svg": "48463",
  "./luggage_16.svg": "30230",
  "./luggage_24.svg": "88448",
  "./magic_16.svg": "52393",
  "./magic_24.svg": "45271",
  "./mails_16.svg": "3872",
  "./mails_24.svg": "7747",
  "./make_default_16.svg": "89074",
  "./make_default_24.svg": "74648",
  "./male_16.svg": "25686",
  "./male_24.svg": "37497",
  "./manager_report_16.svg": "17970",
  "./manager_report_24.svg": "66740",
  "./mark_as_read_16.svg": "41880",
  "./mark_as_read_24.svg": "60653",
  "./marketplace_16.svg": "38704",
  "./marketplace_24.svg": "5625",
  "./media_16.svg": "51059",
  "./media_24.svg": "11011",
  "./megaphone_16.svg": "13482",
  "./megaphone_24.svg": "57178",
  "./menu_16.svg": "52098",
  "./menu_24.svg": "72026",
  "./menu_arrow_left_16.svg": "85404",
  "./menu_arrow_left_24.svg": "27139",
  "./menu_arrow_right_16.svg": "35874",
  "./menu_arrow_right_24.svg": "16665",
  "./merchant_16.svg": "94161",
  "./merchant_24.svg": "22488",
  "./message_16.svg": "21154",
  "./message_24.svg": "12338",
  "./messages_plural_16.svg": "27120",
  "./messages_plural_24.svg": "76808",
  "./mews_logo_16.svg": "76991",
  "./mews_logo_24.svg": "86694",
  "./microphone_16.svg": "60174",
  "./microphone_24.svg": "37291",
  "./military_16.svg": "70060",
  "./military_24.svg": "48918",
  "./minus_16.svg": "80994",
  "./minus_24.svg": "10377",
  "./minus_simple_16.svg": "8481",
  "./minus_simple_24.svg": "19814",
  "./more_16.svg": "41365",
  "./more_24.svg": "30090",
  "./move_16.svg": "84367",
  "./move_24.svg": "56672",
  "./move_payment_16.svg": "42815",
  "./move_payment_24.svg": "21729",
  "./move_payment_horizontal_16.svg": "74505",
  "./move_payment_horizontal_24.svg": "22868",
  "./nonbreaking_space_16.svg": "64512",
  "./nonbreaking_space_24.svg": "39067",
  "./notes_16.svg": "31547",
  "./notes_24.svg": "38653",
  "./notifications_16.svg": "40928",
  "./notifications_24.svg": "69346",
  "./occupancy_16.svg": "58467",
  "./occupancy_24.svg": "32017",
  "./operations_16.svg": "90659",
  "./operations_24.svg": "90509",
  "./out_of_order_16.svg": "97521",
  "./out_of_order_24.svg": "29189",
  "./paperclip_16.svg": "40340",
  "./paperclip_24.svg": "77484",
  "./passport_16.svg": "9882",
  "./passport_24.svg": "15467",
  "./past_shifts_16.svg": "33909",
  "./past_shifts_24.svg": "33714",
  "./paymaster_16.svg": "23850",
  "./paymaster_24.svg": "77457",
  "./payment_attempts_16.svg": "74424",
  "./payment_attempts_24.svg": "72194",
  "./payment_card_16.svg": "70166",
  "./payment_card_24.svg": "15274",
  "./payment_report_16.svg": "7751",
  "./payment_report_24.svg": "85766",
  "./payment_request_16.svg": "62851",
  "./payment_request_24.svg": "36921",
  "./payments_16.svg": "81998",
  "./payments_24.svg": "94951",
  "./phone_16.svg": "47019",
  "./phone_24.svg": "75871",
  "./photo_expand_16.svg": "78289",
  "./photo_expand_24.svg": "28935",
  "./pin_16.svg": "16084",
  "./pin_24.svg": "13549",
  "./places_16.svg": "46272",
  "./places_24.svg": "56123",
  "./places_pin_16.svg": "16829",
  "./places_pin_24.svg": "77783",
  "./plane_16.svg": "94496",
  "./plane_24.svg": "25231",
  "./platform_migrations_16.svg": "70031",
  "./platform_migrations_24.svg": "34863",
  "./plus_16.svg": "10128",
  "./plus_24.svg": "83355",
  "./plus_simple_16.svg": "57825",
  "./plus_simple_24.svg": "97320",
  "./posting_journal_16.svg": "99560",
  "./posting_journal_24.svg": "38326",
  "./power_bi_16.svg": "61201",
  "./power_bi_24.svg": "30591",
  "./preauthorization_16.svg": "35293",
  "./preauthorization_24.svg": "60799",
  "./pricing_16.svg": "92136",
  "./pricing_24.svg": "58351",
  "./print_16.svg": "23354",
  "./print_24.svg": "9419",
  "./print_pdf_16.svg": "55905",
  "./print_pdf_24.svg": "65563",
  "./problematic_16.svg": "99615",
  "./problematic_24.svg": "50000",
  "./product_16.svg": "35333",
  "./product_24.svg": "5442",
  "./product_report_16.svg": "93972",
  "./product_report_24.svg": "76733",
  "./profile_16.svg": "34723",
  "./profile_24.svg": "8294",
  "./profiles_16.svg": "39370",
  "./profiles_24.svg": "77133",
  "./property_16.svg": "47174",
  "./property_24.svg": "39516",
  "./queues_16.svg": "27274",
  "./queues_24.svg": "9166",
  "./quote_16.svg": "8396",
  "./quote_24.svg": "54818",
  "./radio_empty_16.svg": "19799",
  "./radio_empty_24.svg": "97178",
  "./radio_selected_16.svg": "53042",
  "./radio_selected_24.svg": "2403",
  "./rate_management_16.svg": "12415",
  "./rate_management_24.svg": "32377",
  "./rebate_16.svg": "1112",
  "./rebate_24.svg": "83982",
  "./refresh_16.svg": "7864",
  "./refresh_24.svg": "77788",
  "./refund_16.svg": "18574",
  "./refund_24.svg": "63939",
  "./report_bug_16.svg": "64482",
  "./report_bug_24.svg": "39616",
  "./reservation_group_16.svg": "91927",
  "./reservation_group_24.svg": "40675",
  "./reservation_overview_16.svg": "53480",
  "./reservation_overview_24.svg": "29554",
  "./reservation_preview_16.svg": "54267",
  "./reservation_preview_24.svg": "85317",
  "./reservation_properties_16.svg": "66944",
  "./reservation_properties_24.svg": "64053",
  "./reservation_report_16.svg": "28972",
  "./reservation_report_24.svg": "9754",
  "./reservations_16.svg": "47756",
  "./reservations_24.svg": "10611",
  "./reset_16.svg": "84945",
  "./reset_24.svg": "9793",
  "./restore_16.svg": "18409",
  "./restore_24.svg": "82801",
  "./restriction_16.svg": "3177",
  "./restriction_24.svg": "87672",
  "./return_16.svg": "37959",
  "./return_24.svg": "65714",
  "./returning_16.svg": "93907",
  "./returning_24.svg": "90257",
  "./room_16.svg": "57982",
  "./room_24.svg": "93473",
  "./scan_id_16.svg": "61512",
  "./scan_id_24.svg": "49468",
  "./scan_qr_16.svg": "63245",
  "./scan_qr_24.svg": "14377",
  "./scanner_16.svg": "20029",
  "./scanner_24.svg": "20726",
  "./schedules_16.svg": "4987",
  "./schedules_24.svg": "74404",
  "./search_16.svg": "19766",
  "./search_24.svg": "84070",
  "./security_16.svg": "57957",
  "./security_24.svg": "80145",
  "./send_message_16.svg": "10228",
  "./send_message_24.svg": "33810",
  "./service_order_16.svg": "90642",
  "./service_order_24.svg": "94950",
  "./services_16.svg": "21181",
  "./services_24.svg": "34952",
  "./settings_16.svg": "98325",
  "./settings_24.svg": "11669",
  "./settings_user_16.svg": "7050",
  "./settings_user_24.svg": "67258",
  "./share_16.svg": "53781",
  "./share_24.svg": "93728",
  "./shared_data_16.svg": "82868",
  "./shared_data_24.svg": "37380",
  "./show_16.svg": "46903",
  "./show_24.svg": "89462",
  "./shrink_16.svg": "57487",
  "./shrink_24.svg": "55765",
  "./space_status_16.svg": "28651",
  "./space_status_24.svg": "93659",
  "./special_character_16.svg": "752",
  "./special_character_24.svg": "58430",
  "./spent_nights_16.svg": "14272",
  "./spent_nights_24.svg": "36950",
  "./spinner_16.svg": "93110",
  "./spinner_24.svg": "83050",
  "./split_16.svg": "40987",
  "./split_24.svg": "17859",
  "./staff_16.svg": "74135",
  "./staff_24.svg": "28727",
  "./star_filled_16.svg": "32404",
  "./star_filled_24.svg": "83704",
  "./stars_16.svg": "6669",
  "./stars_24.svg": "35832",
  "./statistics_16.svg": "50411",
  "./statistics_24.svg": "12793",
  "./stayovers_16.svg": "82107",
  "./stayovers_24.svg": "23257",
  "./strikethrough_16.svg": "76787",
  "./strikethrough_24.svg": "27696",
  "./subscription_16.svg": "66848",
  "./subscription_24.svg": "22082",
  "./summary_16.svg": "59520",
  "./summary_24.svg": "89550",
  "./summary_order_16.svg": "56275",
  "./summary_order_24.svg": "93838",
  "./switch_video_16.svg": "8699",
  "./switch_video_24.svg": "26335",
  "./targets_16.svg": "92234",
  "./targets_24.svg": "79281",
  "./tasks_16.svg": "33599",
  "./tasks_24.svg": "11091",
  "./tax_environment_16.svg": "14167",
  "./tax_environment_24.svg": "94463",
  "./team_area_16.svg": "18660",
  "./team_area_24.svg": "58869",
  "./tent_16.svg": "85578",
  "./tent_24.svg": "69427",
  "./terminal_16.svg": "14792",
  "./terminal_24.svg": "95471",
  "./terminal_payment_16.svg": "61180",
  "./terminal_payment_24.svg": "821",
  "./text_align_center_16.svg": "50002",
  "./text_align_center_24.svg": "59048",
  "./text_align_justify_16.svg": "91361",
  "./text_align_justify_24.svg": "64030",
  "./text_align_left_16.svg": "36156",
  "./text_align_left_24.svg": "65278",
  "./text_align_right_16.svg": "6523",
  "./text_align_right_24.svg": "44305",
  "./text_line_height_16.svg": "42719",
  "./text_line_height_24.svg": "32732",
  "./thumbs_down_16.svg": "31453",
  "./thumbs_down_24.svg": "51030",
  "./thumbs_up_16.svg": "93071",
  "./thumbs_up_24.svg": "63996",
  "./time_16.svg": "72734",
  "./time_24.svg": "8328",
  "./timeline_16.svg": "45897",
  "./timeline_24.svg": "64072",
  "./timeline_compact_16.svg": "40582",
  "./timeline_compact_24.svg": "29378",
  "./timeline_dense_16.svg": "88265",
  "./timeline_dense_24.svg": "9142",
  "./timeline_spacious_16.svg": "3988",
  "./timeline_spacious_24.svg": "98947",
  "./toggle_left_16.svg": "52410",
  "./toggle_left_24.svg": "14040",
  "./toggle_right_16.svg": "58418",
  "./toggle_right_24.svg": "22421",
  "./top_management_16.svg": "23713",
  "./top_management_24.svg": "26276",
  "./train_16.svg": "68144",
  "./train_24.svg": "45049",
  "./travel_agency_16.svg": "64675",
  "./travel_agency_24.svg": "78472",
  "./travel_club_16.svg": "82769",
  "./travel_club_24.svg": "67499",
  "./travel_visa_16.svg": "43023",
  "./travel_visa_24.svg": "44898",
  "./tripadvisor_16.svg": "27040",
  "./tripadvisor_24.svg": "69711",
  "./twitter_16.svg": "73165",
  "./twitter_24.svg": "53816",
  "./underline_16.svg": "68578",
  "./underline_24.svg": "97707",
  "./unlock_16.svg": "16924",
  "./unlock_24.svg": "14652",
  "./upgraded_16.svg": "67552",
  "./upgraded_24.svg": "40957",
  "./upload_16.svg": "43961",
  "./upload_24.svg": "76440",
  "./user_card_stack_16.svg": "57989",
  "./user_card_stack_24.svg": "56116",
  "./user_clock_16.svg": "5224",
  "./user_clock_24.svg": "65825",
  "./user_refresh_16.svg": "83184",
  "./user_refresh_24.svg": "16211",
  "./very_important_16.svg": "88817",
  "./very_important_24.svg": "40003",
  "./view_off_16.svg": "54735",
  "./view_off_24.svg": "99551",
  "./view_report_16.svg": "31984",
  "./view_report_24.svg": "53475",
  "./website_16.svg": "90258",
  "./website_24.svg": "36590",
  "./wellness_16.svg": "9363",
  "./wellness_24.svg": "13488",
  "./window_16.svg": "8322",
  "./window_24.svg": "70200"
};


function webpackAsyncContext(req) {
  return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
  return __webpack_require__.e(/* lazy-once context | icons */ "979").then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 92585;
module.exports = webpackAsyncContext;
